import { Component, OnInit } from '@angular/core';
import { EntrySelect } from './../../shared/models/EntrySelect.model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, RequiredValidator, Validators } from '@angular/forms';
import { RestService } from '../../shared/services/rest.service';
import { SessionService } from '../../shared/services/session.service';
import { MessageService } from '../../shared/message.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-selecionar-empresa-perfil',
  templateUrl: './selecionar-empresa-perfil.component.html',
  styleUrls: ['./selecionar-empresa-perfil.component.css']
})
export class SelecionarEmpresaPerfilComponent implements OnInit {

  ListTipoEmpresa: Array<EntrySelect>=[];
  ListEmpresa: Array<EntrySelect>=[];
  resourceForm: FormGroup;
  tipoEmpresaUser = this.session.getTipoEmpresa();
  currentEmpresa: any = this.session.getCurrentEmpresa();
  constructor(
    private formBuilder: FormBuilder,
    public bsModalRef: BsModalRef,
    public rest: RestService,
    private session: SessionService,
    private info: MessageService,
    private router: Router
    ) {
         this.ListTipoEmpresa = [
            { value: 'CORPORATE', label: 'Empresa' },
            { value: 'REGULADORA', label: 'Reguladora' },
            { value: 'OFICINA', label: 'Oficina' }
          ];   
     }

  ngOnInit(): void {
    this.resourceForm = this.formBuilder.group({
      tipo_empresa: [this.currentEmpresa.tipo, Validators.required],
      empresa_selecionada: [JSON.stringify(this.currentEmpresa), Validators.required]
    });
    this.onSelectTipoEmpresa(false);
  }

  onSelectTipoEmpresa(clear=true) {
    let tipoSelecionado = this.resourceForm.get('tipo_empresa')?.value;//obtem o tipo de empresa selecionado
      if(clear){
        this.resourceForm.get('empresa_selecionada')?.setValue(null);
      }
      
      //É master (ARCO)?
      if(this.session.isMaster(true)==false && this.session.getTipoEmpresa()==tipoSelecionado){
        let currentEmpresa = this.session.getCurrentEmpresa();
        let key = JSON.stringify(currentEmpresa);
        this.ListEmpresa.push({ 'value': key, 'label': currentEmpresa.razaoSocial });
        this.resourceForm.get('empresa_selecionada')?.setValue(key);
        return;
      }

      this.rest.getEmpresasFilter(tipoSelecionado,"all", "", 1, 9999999, true).subscribe(
        data => {
          var response = JSON.parse(JSON.stringify(data));        
          let dados = response.data;
          this.ListEmpresa = [];
          dados.forEach((item) => {
            let key = {"tipo": tipoSelecionado, 
                      "cnpj": item.cnpj, 
                      'secretKey': item.secret_key, 
                      'razaoSocial': item.razao_social, 
                      'uuid': item.uuid,
                      "idPlan": item.idPlan };
            this.ListEmpresa.push({ 'value': JSON.stringify(key), 'label': item.razao_social });
          })          
        });
  }

  onSubmit(){

    if (this.resourceForm.invalid) {
      this.resourceForm.markAllAsTouched();
      this.info.showErro("Verifique o preenchimento dos campos obrigatórios");
      return;
    }

    let current = this.resourceForm.get('empresa_selecionada')?.value;
    if (current) {
      //console.log(JSON.parse(current));
      this.session.setCurrentEmpresa(JSON.parse(current));
    }

    this.redirectTo('/orcamento/todos/?'+new Date().getTime());   
    //window.location.reload();
    this.bsModalRef.hide();//fecha modal

  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    this.router.navigateByUrl(uri));
 }
}
